import React from 'react';
import './StartDate.scss';

type StartDateProps = {
    startDateTime: string;
    startMonthAbbr: string;
    startDay: string;
};

export const StartDate = ({
    startDateTime,
    startMonthAbbr,
    startDay,
}: StartDateProps) => {
    return (
        <time className="start-date" dateTime={startDateTime}>
            {startMonthAbbr} {startDay}
        </time>
    );
};
